"use strict";

//TODO: test this
module.exports = {

    /**
     * Used to encode strings to URL safe query strings
     * @param {string} value
     */
    encode: function encode(value) {
        return encodeURIComponent(value).replace(/'/g, "%27").replace(/"/g, "%22");
    },
    /**
     * Decode a string value that was encoded with the 'encode' method above
     * @param {string} value
     * @returns {string} decoded string
     */
    decode: function decode(value) {
        return decodeURIComponent(value.replace(/\+/g, " "));
    },
    deconstructUrl: function deconstructUrl(url) {
        var parser = document.createElement('a');
        parser.href = url;

        return {
            port: parser.port,
            hostname: parser.hostname,
            pathname: parser.pathname,
            queryString: parser.search
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/UrlUtility.js
// module id = 331
// module chunks = 0